<template>
  <h2>Настройки</h2>
  <section v-if="company?.name">
    <CompanyBlock :company="company" />
    <p class="sign-text">
      Остаток подписей: <span class="sign-count">{{ signings }}</span>
    </p>
  </section>
  <section v-if="isKeyAdded">
    <div class="success-block">
      API-ключ добавлен
    </div>
  </section>
  <section>
    <div class="btns">
      <PInput placeholder="API-ключ" v-model="apiKey" :status="true" />
    </div>
    <PButton title="Сохранить" @click="save()" />
  </section>
  <section class="no_profile">
    Если у вас нет аккаунта, <a href="https://podpislon.ru/signup?utm_source=yclients&utm_medium=market" target="_blank">зарегистрируйтесь</a>
  </section>
</template>

<script lang="ts">
import PButton from "@/components/ui/PButton.vue";
import PInput from "@/components/ui/PInput.vue";
import { defineComponent, onMounted, ref } from "vue";
import SAPI from "../api/slon";
import { state } from "@/store/state";
import api from "@/api/api";
import CompanyBlock from "@/components/blocks/CompanyBlock.vue";
import { CompanyInfo } from "@/interfaces/company";

export default defineComponent({
  components: { PInput, PButton, CompanyBlock },
  setup() {
    const apiKey = ref<string>("");
    const company = ref<CompanyInfo>();
    const signings = ref<number | string>(),
      isKeyAdded = ref<boolean>(false);
    onMounted(async () => {
      isKeyAdded.value = await api.getIsKeyAdded();
      apiKey.value = await api.getKey();
    });
    return {
      apiKey,
      company,
      signings,
      isKeyAdded
    };
  },
  methods: {
    async save() {
      if (!this.apiKey.length) return;
      state.apiKey = this.apiKey;
      const saveRes = await api.save(state.salon_id, state.apiKey);
      if (saveRes) {
        this.getData();
      }
    },
    async getData() {
      const cData = await SAPI.getInfo();
      if (!cData.status) {
        return;
      }

      this.company = cData.company;
      this.signings = cData.signings;
    },
  },
});
</script>
<style>
p {
  margin-bottom: 16px;
}
.sign-text {
  font-size: 12px;
  color: var(--primary-dark);
}
.sign-count{
    color: var(--primary-black);
    font-size: 14px;
    font-weight: 500;
}
.no_profile{
    margin-top: 16px;
}
.no_profile a{
    color: var(--main-color);
}
.success-block {
    margin-bottom: 16px;
    color: #4CAF50;
    border: 1px solid #4CAF50;
    border-radius: 4px;
    padding: 10px;
    background-color: #f4fff5;
}
</style>